// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as PnMRepoConfig$PorterinFeature from "./PnMRepoConfig.mjs";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";

var dummyPnMValidateGeoregionIntraResponse = {
    "shifting_type": {
      "type": "intra_city",
      "geo_region_id": 1
    }
  };

function validateGeoregion(_pickup_address, _drop_address, _mobile_number, _product_flow) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMValidateGeoregionApiResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyPnMValidateGeoregionIntraResponse
                        });
                  })));
}

var dummyPnMFormSubmissionResponse = { "order_interest": {
      "external_id":"e08b6f5d-ee8c-4c88-b32f-5fc1cd3970b0",
    }
  };

function createPnMOrderInterest(_form_data) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMCreateOrderInterestApiResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyPnMFormSubmissionResponse
                        });
                  })));
}

var dummyBasicShiftingDetailsFormSubmissionResponse = {
    "sr_external_id": "a21ebafc-356f-4e49-8c9c-5bfd380502bd"
  };

var dummytPnMShiftReqLocationDetailsSubmissionResponse = {
      "sr_external_id": "a21ebafc-356f-4e49-8c9c-5bfd380502bd"
    };

function submitPnMShiftReqBasicDetails(_data, _shift_req_id) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMShiftReqBasicDetailsApiResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyBasicShiftingDetailsFormSubmissionResponse
                        });
                  })));
}

function submitPnMShiftReqLocationDetails(_form_data, _shift_req_id, _source) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMShiftReqLocationDetailsApiResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummytPnMShiftReqLocationDetailsSubmissionResponse
                        });
                  })));
}

var dummyPnMPathsResponse = {
    "data": [
      {
        "id": 1,
        "attributes": {
            "page_path": "bangalore",
            "city_label": "default ",
            "createdAt": "2023-11-02T12:10:53.214Z",
            "updatedAt": "2023-11-02T12:19:12.506Z",
            "publishedAt": "2023-11-02T12:10:57.434Z"
        }
      },
      {
        "id": 2,
        "attributes": {
            "page_path": "mumbai",
            "city_label": "andheri",
            "createdAt": "2023-11-02T12:19:22.820Z",
            "updatedAt": "2023-11-02T12:19:24.765Z",
            "publishedAt": "2023-11-02T12:19:24.758Z"
        }
      },
    ],
    "meta": {
      "pagination": {
        "page": 1,
        "pageSize": 150,
        "pageCount": 1,
        "total": 2
      }
    }
  };

var dummyPnMDataResponse = {
  "id": 1,
  "page_path": "bangalore",
  "city_label": "bangalore",
  "show_house_field": true,
  "createdAt": "2025-10-29T06:56:39.841Z",
  "updatedAt": "2025-11-05T12:36:18.195Z",
  "publishedAt": "2025-10-29T06:59:15.894Z",
  "meta_data": {
    "id": 503,
    "title": "Top Packers and Movers in Mumbai",
    "description": "Rely on Porter Packers and Movers in Mumbai for hassle-free house shifting starting at Rs. 1200.",
    "faq_schema": null,
    "review_schema": {
      "name": "Courier",
      "@type": "Product",
      "brand": {
        "name": "Porter",
        "@type": "Brand"
      },
      "reviews": [
        {
          "@type": "Review",
          "author": {
            "name": "Alisha Saha",
            "@type": "Person"
          },
          "description": "I have used Porter for sending local and intercity couriers. I recommend Porter courier service because it is highly reliable and makes timely deliveries.",
          "reviewRating": {
            "@type": "Rating",
            "bestRating": "5",
            "ratingValue": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Review",
          "author": {
            "name": "Amit  Singh",
            "@type": "Person"
          },
          "description": "With Porter, I experienced smooth and timely delivery of my couriers. Thank you Porter Courier for sending goods safely. Highly recommended.",
          "reviewRating": {
            "@type": "Rating",
            "bestRating": "5",
            "ratingValue": "4",
            "worstRating": "1"
          }
        },
        {
          "@type": "Review",
          "author": {
            "name": "Mobashir Hammad",
            "@type": "Person"
          },
          "description": "Got really good service from Porter! I wasn't sure if they'd deliver to my faraway village, but they did better than I expected, delivering everywhere in India. I'm very impressed!",
          "reviewRating": {
            "@type": "Rating",
            "bestRating": "5",
            "ratingValue": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Review",
          "author": {
            "name": "Abhaya Simha",
            "@type": "Person"
          },
          "description": "Sending the package was super easy this time! I didn't have to bother printing and sticking parcel labels; I just used the CR number. I hope Porter keeps offering this option as it is convenient.",
          "reviewRating": {
            "@type": "Rating",
            "bestRating": "5",
            "ratingValue": "5",
            "worstRating": "1"
          }
        }
      ],
      "@context": "http://schema.org/",
      "description": "Are you looking for a reliable courier partner who can provide seamless shipping solutions? Look no further than Porter Courier! Our stress-free courier delivery services are tailored to your local or regional needs.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "609000"
      }
    },
    "local_business_schema": null,
    "is_no_index": false
  },
  "hero_section": {
    "id": 410,
    "title": "Top Packers and Movers in Mumbai\n",
    "sub_text": "Rely on Porter Packers and Movers in Mumbai for hassle-free house shifting starting at Rs. 1200.\n\n",
    "banner_img": {
      "id": 3206,
      "alt_text": "Bangalore",
      "image": {
        "id": 468,
        "name": "Bangalore_optimised_50 (1).webp",
        "alternativeText": null,
        "caption": null,
        "width": 960,
        "height": 439,
        "formats": {
          "small": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/small_Bangalore_optimised_50_1_c3bff25b46/small_Bangalore_optimised_50_1_c3bff25b46.webp",
            "hash": "small_Bangalore_optimised_50_1_c3bff25b46",
            "mime": "image/webp",
            "name": "small_Bangalore_optimised_50 (1).webp",
            "path": null,
            "size": 14.34,
            "width": 500,
            "height": 229,
            "isUrlSigned": true
          },
          "medium": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/medium_Bangalore_optimised_50_1_c3bff25b46/medium_Bangalore_optimised_50_1_c3bff25b46.webp",
            "hash": "medium_Bangalore_optimised_50_1_c3bff25b46",
            "mime": "image/webp",
            "name": "medium_Bangalore_optimised_50 (1).webp",
            "path": null,
            "size": 21.21,
            "width": 750,
            "height": 343,
            "isUrlSigned": true
          },
          "thumbnail": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/thumbnail_Bangalore_optimised_50_1_c3bff25b46/thumbnail_Bangalore_optimised_50_1_c3bff25b46.webp",
            "hash": "thumbnail_Bangalore_optimised_50_1_c3bff25b46",
            "mime": "image/webp",
            "name": "thumbnail_Bangalore_optimised_50 (1).webp",
            "path": null,
            "size": 4.88,
            "width": 245,
            "height": 112,
            "isUrlSigned": true
          }
        },
        "hash": "Bangalore_optimised_50_1_c3bff25b46",
        "ext": ".webp",
        "mime": "image/webp",
        "size": 20.04,
        "url": "https://nest-platform-assets.porter.in/Bangalore_optimised_50_1_c3bff25b46/Bangalore_optimised_50_1_c3bff25b46.webp",
        "previewUrl": null,
        "provider": "strapi-provider-upload-gcs-cdn",
        "provider_metadata": null,
        "folderPath": "/28",
        "createdAt": "2025-05-05T21:07:31.593Z",
        "updatedAt": "2025-11-05T12:36:05.203Z",
        "isUrlSigned": true
      }
    },
    "know_more_cta": {
      "id": 1361,
      "label": "Know More",
      "href": "#vehicle-fleet"
    },
    "banner_img_mobile": {
      "id": 3203,
      "alt_text": "Banner Image",
      "image": {
        "id": 315,
        "name": "Turkey-New-mobile-banner.png",
        "alternativeText": null,
        "caption": null,
        "width": 420,
        "height": 500,
        "formats": {
          "thumbnail": {
            "ext": ".png",
            "url": "https://nest-platform-assets.porter.in/thumbnail_Turkey_New_mobile_banner_25d4c41736/thumbnail_Turkey_New_mobile_banner_25d4c41736.png",
            "hash": "thumbnail_Turkey_New_mobile_banner_25d4c41736",
            "mime": "image/png",
            "name": "thumbnail_Turkey-New-mobile-banner.png",
            "path": null,
            "size": 41.13,
            "width": 131,
            "height": 156,
            "isUrlSigned": true
          }
        },
        "hash": "Turkey_New_mobile_banner_25d4c41736",
        "ext": ".png",
        "mime": "image/png",
        "size": 65.72,
        "url": "https://nest-platform-assets.porter.in/Turkey_New_mobile_banner_25d4c41736/Turkey_New_mobile_banner_25d4c41736.png",
        "previewUrl": null,
        "provider": "strapi-provider-upload-gcs-cdn",
        "provider_metadata": null,
        "folderPath": "/",
        "createdAt": "2025-02-21T12:03:09.495Z",
        "updatedAt": "2025-10-29T06:58:58.182Z",
        "isUrlSigned": true
      }
    }
  },
  "section_seo": {
    "id": 35,
    "text": "Book Mini Trucks for Goods Transport in Bangalore",
    "identifier": "IN - Bangalore Trucks",
    "sub_text": "Navigating Bangalore’s traffic can make goods transportation a significant challenge. That’s where Porter steps in to simplify the process. Our mini truck service is tailored to help you transport items across the city, even in its most congested areas, meeting all your transportation needs.\n\nWhether you're a business owner or an individual, Porter offers reliable truck booking services designed to suit your requirements. From mini trucks to tempos, we provide a range of vehicles at affordable rates, ensuring you have the right option for your goods.\n\nOur secure online booking process lets you book a truck in just minutes, making logistics stress-free. Whether you’re delivering kitchen appliances, moving furniture, or transporting other items, Porter ensures convenience and safety. A trusted driver-partner is assigned to transport your consignment securely to their destination.\n\nWith Porter, you can depend on us for your goods transportation needs—anytime, anywhere in Bangalore.\n\n\n### How to Book Mini Trucks Online in Bangalore?\n\nGone are the days of dealing with long wait times and confusing truck booking processes. With Porter, booking a truck in Bangalore is now just a few steps away. Whether you're shifting items within city or managing business deliveries, Porter simplifies the process with a smooth app experience. Here’s how you can book a truck in minutes:\n\n1. Open the Porter app\n\n2. Enter the pickup location\n\n3. Click on ‘Trucks’\n\n4. Set the drop location and add stops (if necessary)\n\n5. Enter the receiver’s details\n\n6. Press ‘Confirm and Proceed’\n\n7. Select any truck, choose the payment method, and click on ‘Goods Type’\n\n8. Choose the type of goods and enter its quantity\n\n9. Tap on ‘Update’\n\n10. Apply coupons (if available) and click on ‘Book Pickup 8ft’\n\nOnce your booking is confirmed, our verified driver-partner will arrive at your location, ensuring your consignment is safely transported to their destination. With Porter, you get affordable pricing, a reliable fleet, and a hassle-free booking experience — all designed to make your delivery needs smooth and efficient. So why wait? Book your truck with Porter today and experience convenience like never before!\n\n\t\n\n\n### Types of Mini Trucks Available in Bangalore\n\nExperience the ease of online truck booking in Bangalore with Porter — your trusted partner for reliable and efficient goods transportation across the city. Here are the different types of mini trucks available in Bangalore:\n\n\n\n* **Three-Wheeler:** The three-wheeler services in Bangalore are a great option for delivering small items. The fare starts from ₹205 and comes with a carrying capacity of 500 kgs.\n* **Pickup 8ft:** For heavyweight consignments, go with Pickup 8ft — the perfect choice for large loads with a base fare of just ₹330.\n* **Tata 407:** Need to transport heavy goods across Bangalore? The Tata 407 has got you covered! With Porter, you can easily book a Tata 407 at affordable per-km rates, ensuring a smooth and cost-effective delivery every time.\n* **Tata Ace:** Need to transport medium or large items in Bangalore? Book a Tata Ace with Porter! With a 750 kg capacity and budget-friendly rates, enjoy reliable and hassle-free deliveries.\n\nPorter can be one of the best choices for online truck booking in Bangalore for the following reasons: \n\n\n\n* **Hassle-free Booking:** The Porter app lets you conveniently book a mini truck in Bangalore whenever you need. You can easily complete the online truck booking in Bangalore in just a few minutes.\n* **Safe and Reliable:** We ensure that our trucks are in good condition and capable of delivering consignments of all types.\n* **Affordable Rates:** Porter has transparent rates to book mini trucks in Bangalore. For example, you can book a Three-Wheeler in Bangalore for as low as ₹205 as the base fare with an additional charge of ₹100.\n* **Wide Reach and Scale:** Porter has a vast network of reliable trucks, verified driver-partners, and a broad reach across locations in Bangalore to cater to your goods transportation needs anytime and anywhere.\n\nWith Porter, you get affordable pricing, a reliable fleet, and a hassle-free booking experience — all designed to make your logistics needs smooth and efficient.",
    "createdAt": "2025-05-05T09:32:20.794Z",
    "updatedAt": "2025-07-10T15:31:07.655Z",
    "publishedAt": "2025-05-05T09:33:04.627Z"
  },
  "section_banner": {
    "id": 8,
    "identifier": "IN - Bangalore",
    "createdAt": "2025-05-05T21:49:14.109Z",
    "updatedAt": "2025-08-07T06:40:31.704Z",
    "publishedAt": "2025-05-05T21:49:15.325Z",
    "banner_img": {
      "id": 2296,
      "alt_text": "Bangalore",
      "image": {
        "id": 548,
        "name": "trucks__keyword.webp",
        "alternativeText": null,
        "caption": null,
        "width": 1286,
        "height": 585,
        "formats": {
          "large": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/large_trucks_keyword_dffb597b36/large_trucks_keyword_dffb597b36.webp",
            "hash": "large_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "large_trucks__keyword.webp",
            "path": null,
            "size": 15.38,
            "width": 1000,
            "height": 455,
            "isUrlSigned": true
          },
          "small": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/small_trucks_keyword_dffb597b36/small_trucks_keyword_dffb597b36.webp",
            "hash": "small_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "small_trucks__keyword.webp",
            "path": null,
            "size": 7.33,
            "width": 500,
            "height": 227,
            "isUrlSigned": true
          },
          "medium": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/medium_trucks_keyword_dffb597b36/medium_trucks_keyword_dffb597b36.webp",
            "hash": "medium_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "medium_trucks__keyword.webp",
            "path": null,
            "size": 11.33,
            "width": 750,
            "height": 341,
            "isUrlSigned": true
          },
          "thumbnail": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/thumbnail_trucks_keyword_dffb597b36/thumbnail_trucks_keyword_dffb597b36.webp",
            "hash": "thumbnail_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "thumbnail_trucks__keyword.webp",
            "path": null,
            "size": 3.28,
            "width": 245,
            "height": 111,
            "isUrlSigned": true
          }
        },
        "hash": "trucks_keyword_dffb597b36",
        "ext": ".webp",
        "mime": "image/webp",
        "size": 22.86,
        "url": "https://nest-platform-assets.porter.in/trucks_keyword_dffb597b36/trucks_keyword_dffb597b36.webp",
        "previewUrl": null,
        "provider": "strapi-provider-upload-gcs-cdn",
        "provider_metadata": null,
        "folderPath": "/",
        "createdAt": "2025-05-13T00:05:16.093Z",
        "updatedAt": "2025-05-13T00:05:16.093Z",
        "isUrlSigned": true
      }
    },
    "banner_img_mobile": {
      "id": 2297,
      "alt_text": "Bangalore",
      "image": {
        "id": 548,
        "name": "trucks__keyword.webp",
        "alternativeText": null,
        "caption": null,
        "width": 1286,
        "height": 585,
        "formats": {
          "large": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/large_trucks_keyword_dffb597b36/large_trucks_keyword_dffb597b36.webp",
            "hash": "large_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "large_trucks__keyword.webp",
            "path": null,
            "size": 15.38,
            "width": 1000,
            "height": 455,
            "isUrlSigned": true
          },
          "small": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/small_trucks_keyword_dffb597b36/small_trucks_keyword_dffb597b36.webp",
            "hash": "small_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "small_trucks__keyword.webp",
            "path": null,
            "size": 7.33,
            "width": 500,
            "height": 227,
            "isUrlSigned": true
          },
          "medium": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/medium_trucks_keyword_dffb597b36/medium_trucks_keyword_dffb597b36.webp",
            "hash": "medium_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "medium_trucks__keyword.webp",
            "path": null,
            "size": 11.33,
            "width": 750,
            "height": 341,
            "isUrlSigned": true
          },
          "thumbnail": {
            "ext": ".webp",
            "url": "https://nest-platform-assets.porter.in/thumbnail_trucks_keyword_dffb597b36/thumbnail_trucks_keyword_dffb597b36.webp",
            "hash": "thumbnail_trucks_keyword_dffb597b36",
            "mime": "image/webp",
            "name": "thumbnail_trucks__keyword.webp",
            "path": null,
            "size": 3.28,
            "width": 245,
            "height": 111,
            "isUrlSigned": true
          }
        },
        "hash": "trucks_keyword_dffb597b36",
        "ext": ".webp",
        "mime": "image/webp",
        "size": 22.86,
        "url": "https://nest-platform-assets.porter.in/trucks_keyword_dffb597b36/trucks_keyword_dffb597b36.webp",
        "previewUrl": null,
        "provider": "strapi-provider-upload-gcs-cdn",
        "provider_metadata": null,
        "folderPath": "/",
        "createdAt": "2025-05-13T00:05:16.093Z",
        "updatedAt": "2025-05-13T00:05:16.093Z",
        "isUrlSigned": true
      }
    }
  },
  "section_download": {
    "id": 6,
    "identifier": "en-IN",
    "createdAt": "2025-04-24T10:52:28.679Z",
    "updatedAt": "2025-04-24T10:52:30.596Z",
    "publishedAt": "2025-04-24T10:52:30.584Z",
    "download_app_mobile": {
      "id": 118,
      "title": "Book your order with us on the app!",
      "sub_text": "We are loved by 10,00,000 + customers for our service!",
      "button_label": "Download App",
      "button_href": "https://porter.in/app",
      "app_icon": {
        "id": 1705,
        "alt_text": "Porter App Icon",
        "image": {
          "id": 358,
          "name": "download-app-icon-v2.svg",
          "alternativeText": null,
          "caption": null,
          "width": 88,
          "height": 94,
          "formats": null,
          "hash": "download_app_icon_v2_75a896e37e",
          "ext": ".svg",
          "mime": "image/svg+xml",
          "size": 188.74,
          "url": "https://nest-platform-assets.porter.in/download_app_icon_v2_75a896e37e/download_app_icon_v2_75a896e37e.svg",
          "previewUrl": null,
          "provider": "strapi-provider-upload-gcs-cdn",
          "provider_metadata": null,
          "folderPath": "/",
          "createdAt": "2025-04-15T08:00:14.897Z",
          "updatedAt": "2025-04-27T15:22:02.141Z",
          "isUrlSigned": true
        }
      },
      "google_play_store_image": {
        "id": 1706,
        "alt_text": "Play Store",
        "image": {
          "id": 46,
          "name": "googleplay.png",
          "alternativeText": null,
          "caption": null,
          "width": 488,
          "height": 141,
          "formats": {
            "thumbnail": {
              "ext": ".png",
              "url": "https://nest-platform-assets.porter.in/thumbnail_googleplay_a4716316e8.png",
              "hash": "thumbnail_googleplay_a4716316e8",
              "mime": "image/png",
              "name": "thumbnail_googleplay.png",
              "path": null,
              "size": 8.99,
              "width": 245,
              "height": 71
            }
          },
          "hash": "googleplay_a4716316e8",
          "ext": ".png",
          "mime": "image/png",
          "size": 5.07,
          "url": "https://nest-platform-assets.porter.in/googleplay_a4716316e8.png",
          "previewUrl": null,
          "provider": "aws-s3",
          "provider_metadata": null,
          "folderPath": "/3",
          "createdAt": "2024-06-20T08:08:40.958Z",
          "updatedAt": "2024-06-20T08:08:40.958Z",
          "isUrlSigned": false
        }
      },
      "app_store_image": {
        "id": 1707,
        "alt_text": "App Store",
        "image": {
          "id": 47,
          "name": "appstore.png",
          "alternativeText": null,
          "caption": null,
          "width": 488,
          "height": 141,
          "formats": {
            "thumbnail": {
              "ext": ".png",
              "url": "https://nest-platform-assets.porter.in/thumbnail_appstore_1ca72680f5.png",
              "hash": "thumbnail_appstore_1ca72680f5",
              "mime": "image/png",
              "name": "thumbnail_appstore.png",
              "path": null,
              "size": 8.37,
              "width": 245,
              "height": 71
            }
          },
          "hash": "appstore_1ca72680f5",
          "ext": ".png",
          "mime": "image/png",
          "size": 4.73,
          "url": "https://nest-platform-assets.porter.in/appstore_1ca72680f5.png",
          "previewUrl": null,
          "provider": "aws-s3",
          "provider_metadata": null,
          "folderPath": "/3",
          "createdAt": "2024-06-20T08:08:51.750Z",
          "updatedAt": "2024-06-20T08:08:51.750Z",
          "isUrlSigned": false
        }
      }
    },
    "download_app_desktop": {
      "id": 108,
      "title": "Think Logistics, Think Porter!",
      "sub_title": "Get the Porter mobile app to start booking your orders!",
      "qr_text": "Scan to download our app!",
      "qr": {
        "id": 1708,
        "alt_text": "QR code",
        "image": {
          "id": 403,
          "name": "download_ind_qr.png",
          "alternativeText": null,
          "caption": null,
          "width": 1024,
          "height": 1024,
          "formats": {
            "large": {
              "ext": ".png",
              "url": "https://nest-platform-assets.porter.in/large_download_ind_qr_24511835e3/large_download_ind_qr_24511835e3.png",
              "hash": "large_download_ind_qr_24511835e3",
              "mime": "image/png",
              "name": "large_download_ind_qr.png",
              "path": null,
              "size": 35.12,
              "width": 1000,
              "height": 1000,
              "isUrlSigned": true
            },
            "small": {
              "ext": ".png",
              "url": "https://nest-platform-assets.porter.in/small_download_ind_qr_24511835e3/small_download_ind_qr_24511835e3.png",
              "hash": "small_download_ind_qr_24511835e3",
              "mime": "image/png",
              "name": "small_download_ind_qr.png",
              "path": null,
              "size": 17.14,
              "width": 500,
              "height": 500,
              "isUrlSigned": true
            },
            "medium": {
              "ext": ".png",
              "url": "https://nest-platform-assets.porter.in/medium_download_ind_qr_24511835e3/medium_download_ind_qr_24511835e3.png",
              "hash": "medium_download_ind_qr_24511835e3",
              "mime": "image/png",
              "name": "medium_download_ind_qr.png",
              "path": null,
              "size": 26.38,
              "width": 750,
              "height": 750,
              "isUrlSigned": true
            },
            "thumbnail": {
              "ext": ".png",
              "url": "https://nest-platform-assets.porter.in/thumbnail_download_ind_qr_24511835e3/thumbnail_download_ind_qr_24511835e3.png",
              "hash": "thumbnail_download_ind_qr_24511835e3",
              "mime": "image/png",
              "name": "thumbnail_download_ind_qr.png",
              "path": null,
              "size": 9.86,
              "width": 156,
              "height": 156,
              "isUrlSigned": true
            }
          },
          "hash": "download_ind_qr_24511835e3",
          "ext": ".png",
          "mime": "image/png",
          "size": 16.31,
          "url": "https://nest-platform-assets.porter.in/download_ind_qr_24511835e3/download_ind_qr_24511835e3.png",
          "previewUrl": null,
          "provider": "strapi-provider-upload-gcs-cdn",
          "provider_metadata": null,
          "folderPath": "/",
          "createdAt": "2025-04-24T10:50:57.244Z",
          "updatedAt": "2025-04-24T10:50:57.244Z",
          "isUrlSigned": true
        }
      }
    }
  },
  "cities": [
    {
      "id": 1,
      "createdAt": "2024-07-08T07:17:39.594Z",
      "updatedAt": "2025-11-05T10:38:52.028Z",
      "publishedAt": "2024-07-08T12:19:33.866Z",
      "locale": "en",
      "identifier": "IN - PnM - Main",
      "image": {
        "id": 1,
        "city_name": "bangalore",
        "city_label": "Bangalore",
        "createdAt": "2024-07-08T07:16:36.673Z",
        "updatedAt": "2024-07-08T12:19:47.527Z",
        "publishedAt": "2024-07-08T12:19:47.520Z",
        "locale": "en",
        "image": {
          "id": 48,
          "alt_text": "city icon",
          "image": {
            "id": 61,
            "name": "dhaka city.svg",
            "alternativeText": null,
            "caption": null,
            "width": 155,
            "height": 150,
            "formats": null,
            "hash": "dhaka_city_6cfa70fffa",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 81.67,
            "url": "https://nest-platform-assets.porter.in/dhaka_city_6cfa70fffa.svg",
            "previewUrl": null,
            "provider": "aws-s3",
            "provider_metadata": null,
            "folderPath": "/3",
            "createdAt": "2024-07-08T07:16:21.996Z",
            "updatedAt": "2024-07-08T07:16:21.996Z",
            "isUrlSigned": false
          }
        },
        "localizations": [
          {
            "id": 2,
            "city_name": "bangalore",
            "city_label": "bangalore",
            "createdAt": "2024-07-08T07:17:15.611Z",
            "updatedAt": "2024-07-09T14:52:18.957Z",
            "publishedAt": "2024-07-09T14:52:18.943Z",
            "locale": "bn-BD"
          }
        ]
      },
      "services": [
        {
          "id": 3,
          "service_name": "Trucks",
          "service_type": "trucks",
          "url": "/trucks",
          "createdAt": "2024-06-20T08:13:56.637Z",
          "updatedAt": "2024-10-09T06:57:12.117Z",
          "publishedAt": "2024-06-20T08:14:00.693Z",
          "locale": "en",
          "service_icon": {
            "id": 12,
            "alt_text": "Trucks Icon",
            "image": {
              "id": 51,
              "name": "trucks_293a94a860_cc4b2d6d06.webp",
              "alternativeText": null,
              "caption": null,
              "width": 200,
              "height": 200,
              "formats": {
                "thumbnail": {
                  "ext": ".webp",
                  "url": "https://nest-platform-assets.porter.in/thumbnail_trucks_293a94a860_cc4b2d6d06_f74f2fa706.webp",
                  "hash": "thumbnail_trucks_293a94a860_cc4b2d6d06_f74f2fa706",
                  "mime": "image/webp",
                  "name": "thumbnail_trucks_293a94a860_cc4b2d6d06.webp",
                  "path": null,
                  "size": 2.66,
                  "width": 156,
                  "height": 156
                }
              },
              "hash": "trucks_293a94a860_cc4b2d6d06_f74f2fa706",
              "ext": ".webp",
              "mime": "image/webp",
              "size": 3.05,
              "url": "https://nest-platform-assets.porter.in/trucks_293a94a860_cc4b2d6d06_f74f2fa706.webp",
              "previewUrl": null,
              "provider": "aws-s3",
              "provider_metadata": null,
              "folderPath": "/3",
              "createdAt": "2024-06-20T08:13:39.935Z",
              "updatedAt": "2024-06-20T08:13:39.935Z",
              "isUrlSigned": false
            }
          },
          "localizations": []
        }
      ],
      "localizations": [
        {
          "id": 2,
          "createdAt": "2024-07-08T07:17:55.060Z",
          "updatedAt": "2024-09-11T06:10:07.300Z",
          "publishedAt": "2024-07-09T14:52:13.276Z",
          "locale": "bn-BD",
          "identifier": null
        }
      ]
    }
  ],
  "section_faqs": {
    "id": 9,
    "identifier": "IN - Trucks - Main",
    "createdAt": "2025-05-05T22:51:38.913Z",
    "updatedAt": "2025-05-05T22:53:10.006Z",
    "publishedAt": "2025-05-05T22:53:10.002Z",
    "faqs_section": {
      "id": 154,
      "title": "Frequently Asked Questions",
      "sub_text": "In case you have more questions, feel free to reach out to us.",
      "faqs": [
        {
          "id": 611,
          "question": "What happens in case of an accident or breakdown during the transportation period?\n",
          "answer": "Porter will always try to provide you with a secure goods transportation service. However, in the event of an accident or breakdown during the transportation period, Porter's support team assists in coordinating necessary arrangements for repairs or alternative transportation, ensuring minimal disruption for customers."
        },
        {
          "id": 610,
          "question": "What should I consider when determining the truck size I need to book?",
          "answer": "When deciding on the truck size to book, consider the volume and weight of your goods and the number of items. Porter's different options, like three-wheelers and four-wheelers, ensure you choose a truck that accommodates your goods comfortably."
        }
      ],
      "toggle_icon": {
        "id": 2349,
        "alt_text": "Toggle icon",
        "image": {
          "id": 41,
          "name": "Arrow icon.svg",
          "alternativeText": null,
          "caption": null,
          "width": 24,
          "height": 24,
          "formats": null,
          "hash": "Arrow_icon_6bd83d3c9e",
          "ext": ".svg",
          "mime": "image/svg+xml",
          "size": 0.37,
          "url": "https://nest-platform-assets.porter.in/Arrow_icon_6bd83d3c9e.svg",
          "previewUrl": null,
          "provider": "aws-s3",
          "provider_metadata": null,
          "folderPath": "/3",
          "createdAt": "2024-06-20T08:04:48.808Z",
          "updatedAt": "2025-09-25T07:15:29.807Z",
          "isUrlSigned": false
        }
      }
    }
  },
  "section_pointers": {
    "id": 1,
    "keyword": "IN- PnM",
    "text": "House Shifting Services with Best Packers and Movers in Bangalore",
    "createdAt": "2025-11-05T12:35:13.009Z",
    "updatedAt": "2025-11-05T12:35:14.375Z",
    "publishedAt": "2025-11-05T12:35:14.368Z",
    "pointers": [
      {
        "id": 6,
        "text": "100% Damage-Free Shifting",
        "sub_text": "Packers and movers services with safety at every step.",
        "icon": {
          "id": 18,
          "alt_text": "Reliable shifting",
          "src_path": {
            "id": 797,
            "name": "Reliable shifting.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Reliable_shifting_1950afb5f0",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 6.85,
            "url": "https://nest-platform-assets.porter.in/Reliable_shifting_1950afb5f0/Reliable_shifting_1950afb5f0.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:33:48.616Z",
            "updatedAt": "2025-11-05T12:33:48.616Z",
            "isUrlSigned": true
          }
        }
      },
      {
        "id": 5,
        "text": "Affordable & Assured",
        "sub_text": "Reliable packers and movers services at economical prices.",
        "icon": {
          "id": 17,
          "alt_text": "Economical prices",
          "src_path": {
            "id": 799,
            "name": "Economical prices.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Economical_prices_8f984dc4c4",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 0.65,
            "url": "https://nest-platform-assets.porter.in/Economical_prices_8f984dc4c4/Economical_prices_8f984dc4c4.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:34:49.804Z",
            "updatedAt": "2025-11-05T12:34:49.804Z",
            "isUrlSigned": true
          }
        }
      },
      {
        "id": 7,
        "text": "Expert Handling",
        "sub_text": "Professionally trained experts for damage-free shifting",
        "icon": {
          "id": 19,
          "alt_text": "Damage-proof packaging",
          "src_path": {
            "id": 798,
            "name": "Damage-proof packaging.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Damage_proof_packaging_f015b0f4b8",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 0.87,
            "url": "https://nest-platform-assets.porter.in/Damage_proof_packaging_f015b0f4b8/Damage_proof_packaging_f015b0f4b8.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:34:49.763Z",
            "updatedAt": "2025-11-05T12:34:49.763Z",
            "isUrlSigned": true
          }
        }
      }
    ]
  },
  "section_addition_service": {
    "id": 1,
    "identifier": "IN - PnM - Main",
    "text": "Need an Extra Hand?",
    "sub_text": "Experience 100% damage-free shifting with Porter Packers & Movers. Enhance your move with our Value Added Services.",
    "createdAt": "2025-11-05T12:25:07.917Z",
    "updatedAt": "2025-11-05T12:27:41.868Z",
    "publishedAt": "2025-11-05T12:27:41.857Z",
    "pointers": [
      {
        "id": 1,
        "text": "Rope Pulling Services",
        "sub_text": "Assistance from experts in handling heavy goods that need extra care",
        "icon": {
          "id": 13,
          "alt_text": "Rope Pulling",
          "src_path": {
            "id": 793,
            "name": "Rope Pulling.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Rope_Pulling_f61107019a",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 5.72,
            "url": "https://nest-platform-assets.porter.in/Rope_Pulling_f61107019a/Rope_Pulling_f61107019a.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:24:55.773Z",
            "updatedAt": "2025-11-05T12:24:55.773Z",
            "isUrlSigned": true
          }
        }
      },
      {
        "id": 3,
        "text": "Installation of Appliances",
        "sub_text": "Un-installation and installation of electrical appliances by professionals",
        "icon": {
          "id": 14,
          "alt_text": "Appliance Installation",
          "src_path": {
            "id": 794,
            "name": "Appliance Installation.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Appliance_Installation_334ab1f19d",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 2.23,
            "url": "https://nest-platform-assets.porter.in/Appliance_Installation_334ab1f19d/Appliance_Installation_334ab1f19d.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:25:51.684Z",
            "updatedAt": "2025-11-05T12:25:51.684Z",
            "isUrlSigned": true
          }
        }
      },
      {
        "id": 4,
        "text": "Professional Electrician",
        "sub_text": "Expertise at your rescue",
        "icon": {
          "id": 15,
          "alt_text": "Electrician Support",
          "src_path": {
            "id": 795,
            "name": "Electrician Support.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Electrician_Support_3dbc1f006d",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 5.43,
            "url": "https://nest-platform-assets.porter.in/Electrician_Support_3dbc1f006d/Electrician_Support_3dbc1f006d.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:26:39.914Z",
            "updatedAt": "2025-11-05T12:26:39.914Z",
            "isUrlSigned": true
          }
        }
      },
      {
        "id": 2,
        "text": "Professional Carpenter",
        "sub_text": "Professionally skilled carpenters in furniture handling",
        "icon": {
          "id": 16,
          "alt_text": "Carpenter",
          "src_path": {
            "id": 796,
            "name": "Carpenter.svg",
            "alternativeText": null,
            "caption": null,
            "width": 58,
            "height": 58,
            "formats": null,
            "hash": "Carpenter_e19f79402e",
            "ext": ".svg",
            "mime": "image/svg+xml",
            "size": 5.51,
            "url": "https://nest-platform-assets.porter.in/Carpenter_e19f79402e/Carpenter_e19f79402e.svg",
            "previewUrl": null,
            "provider": "strapi-provider-upload-gcs-cdn",
            "provider_metadata": null,
            "folderPath": "/",
            "createdAt": "2025-11-05T12:27:12.315Z",
            "updatedAt": "2025-11-05T12:27:12.315Z",
            "isUrlSigned": true
          }
        }
      }
    ]
  },
  "section_testimonials": {
    "id": 1,
    "createdAt": "2025-10-08T10:30:08.013Z",
    "updatedAt": "2025-10-31T10:39:33.509Z",
    "publishedAt": "2025-10-31T10:39:33.503Z",
    "identifier": "IN - PnM - Main",
    "testimonials_section": {
      "id": 1,
      "title": "Some words from our happy customers!",
      "testimonials": [
        {
          "id": 3,
          "customer_name": "Vikas",
          "city": "Bangalore",
          "testimonial_text": "\"Porter's team was punctual, caring, and highly professional. Their self-sufficiency and humility impressed me, along with great customer support. Thank you!\"",
          "rating": 5,
          "porter_service": "Packers and Movers",
          "profile_pic": {
            "id": 1,
            "alt_text": "Vikas"
          },
          "profile_link": null
        },
        {
          "id": 4,
          "customer_name": "Syamantak Mitra",
          "city": "Hyderabad",
          "testimonial_text": "\"Smooth experience with Porter's packers and movers! The team was fantastic, handling every detail. Highly recommend their services!\"",
          "rating": 4,
          "porter_service": "Packers and Movers",
          "profile_pic": {
            "id": 2,
            "alt_text": "Syamantak Mitra"
          },
          "profile_link": null
        },
        {
          "id": 1,
          "customer_name": "Praveen Ketoli",
          "city": "Pune",
          "testimonial_text": "\"Grateful for the punctuality and enthusiasm of the team. They handled items gently, took great care, and placed everything perfectly.\"",
          "rating": 5,
          "porter_service": "Packers and Movers",
          "profile_pic": {
            "id": 3,
            "alt_text": "Praveen Ketoli"
          },
          "profile_link": null
        },
        {
          "id": 2,
          "customer_name": "Virat Maun",
          "city": "Delhi",
          "testimonial_text": "\"Top-notch service! Packing, dismantling, handling, transportation, and re-assembling were excellent. Shifting homes felt incredibly easy. Kudos to the team!\"",
          "rating": 5,
          "porter_service": "Packers and Movers",
          "profile_pic": {
            "id": 4,
            "alt_text": "Virat Maun"
          },
          "profile_link": null
        }
      ]
    }
  },
  "section_internal_links": {
    "id": 1,
    "text": "House Shifting Services Near You",
    "link_section": [
      {
        "text": "Serviceable areas in Bangalore",
        "section_event_label": "Event Label",
        "links": [
          {
            "title": "Packers and Movers in Whitefield",
            "link": "https://porter.in/packers-and-movers/whitefield",
            "section_event_action": "Event Action"
          },
          {
            "title": "Packers and Movers in Indira Nagar",
            "link": "https://porter.in/packers-and-movers/indiranagar-bangalore",
            "section_event_action": "indiranagar-bangalore"
          },
          {
            "title": "Packers and Movers in HSR Layout",
            "link": "https://porter.in/packers-and-movers/hsr-layout",
            "section_event_action": "hsr-layout"
          }
        ]
      },
      {
        "text": "Now in more cities",
        "section_event_label": "shifting",
        "links": [
          {
            "title": "Packers and Movers in Hyderabad",
            "link": "https://porter.in/packers-and-movers/hyderabad",
            "section_event_action": "_self"
          },
          {
            "title": "Packers and Movers in Chennai",
            "link": "https://porter.in/packers-and-movers/chennai",
            "section_event_action": "chennai"
          }
        ]
      }
    ]
  }
};

function getPaths(_locale) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMPathsResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyPnMPathsResponse
                        });
                  })));
}

function getPageContent(_city_name, _locale) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMCityResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: dummyPnMDataResponse
                        });
                  })));
}

export {
  dummyPnMValidateGeoregionIntraResponse ,
  validateGeoregion ,
  dummyPnMFormSubmissionResponse ,
  createPnMOrderInterest ,
  dummyBasicShiftingDetailsFormSubmissionResponse ,
  dummytPnMShiftReqLocationDetailsSubmissionResponse ,
  submitPnMShiftReqBasicDetails ,
  submitPnMShiftReqLocationDetails ,
  dummyPnMPathsResponse ,
  dummyPnMDataResponse ,
  getPaths ,
  getPageContent ,
}
/* PnMRepoConfig-PorterinFeature Not a pure module */
